import React, { useEffect } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { appConstantes } from "../../constantes/appConstantes";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import {
  obtenerOficialCumplimiento,
  setDatos,
  setMessageError,
} from "../../sliceRedux/ValidarReserva.slice";
import Observation from "../../componentes/Observation";
import moment from "moment";

const RevisarOficialCumplimientoConstitucion = (props) => {
  const { showLoader, hideLoader, dispatch, codSolConstitucion, toast } = props;
  const messageError = useSelector((state) => state.validar.messageError);
  const datosOficial = useSelector((state) => state.validar.datos);

  const options = [
    { nemonico: true, descripcion: "Si" },
    { nemonico: false, descripcion: "No" },
  ];
  useEffect(() => {
    showLoader();
    dispatch(obtenerOficialCumplimiento(codSolConstitucion));
  }, []);

  useEffect(() => {
    return () => {
      hideLoader();
      dispatch(setDatos({ ...datosOficial, ...{ code: 0 } }));
    };
  }, [datosOficial.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  return (
    <>
      <div className="card">
        <Observation observationValue={datosOficial?.object?.observacion} />
        <Fieldset legend="Datos personales">
          <div className="grid">
            <div className="flex col-12 md:col-12 ">
              <label
                htmlFor="tipo"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Es socio:
              </label>
              <SelectButton
                id="tipo"
                name="tipo"
                value={datosOficial?.object?.esSocio === "S" ? true : false}
                optionLabel="descripcion"
                optionValue="nemonico"
                allowEmpty={false}
                color="secondary"
                disabled
                options={options}
              />
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="tipoIdentificacion"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Tipo de identificación:
              </label>
              <div className="col">
                <InputText
                  id="tipoIdentificacion"
                  name="tipoIdentificacion"
                  value={datosOficial?.object?.nomTipoIdentificacion ?? ""}
                  emptyMessage={appConstantes.SIN_DATOS}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "110px", textAlign: "left" }}
                required
              >
                Identificación:
              </label>
              <div className="col">
                <InputText
                  id="identificacion"
                  name="identificacion"
                  value={datosOficial?.object?.numIdentificacion ?? ""}
                  autoComplete="off"
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="flex col-12 md:col-12 ">
              <label
                htmlFor="nombres"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Apellidos y nombres:
              </label>
              <div className="col">
                <InputText
                  id="nombres"
                  name="nombres"
                  value={datosOficial?.object?.nombres ?? ""}
                  autoComplete="off"
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>

            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="fechaNombramiento"
                className="mr-2"
                style={{ minWidth: "160px", textAlign: "left" }}
                required
              >
                Fecha de nombramiento:
              </label>
              <div className="col">
                <Calendar
                  id="fechaNombramiento"
                  name="fechaNombramiento"
                  value={
                    datosOficial?.object?.fechaNombramiento
                      ? moment(datosOficial?.object?.fechaNombramiento).toDate()
                      : ""
                  }
                  dateFormat="dd/mm/yy"
                  showIcon
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-2"></div>
        <Fieldset legend="Contacto">
          <div className="grid">
            <div className="flex col-12 md:col-3 ">
              <label
                htmlFor="celular"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
                required
              >
                Celular:
              </label>
              <div className="col">
                <InputText
                  id="celular"
                  name="celular"
                  keyfilter="int"
                  maxLength={10}
                  autoComplete="off"
                  disabled
                  value={datosOficial?.object?.celular ?? ""}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="flex col-12 md:col-3 ">
              <label
                htmlFor="telefono"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
              >
                Teléfono fijo:
              </label>
              <InputText
                id="telefono"
                name="telefono"
                keyfilter="int"
                maxLength={10}
                autoComplete="off"
                disabled
                value={datosOficial?.object?.tlfFijo ?? ""}
                style={{ width: "100%" }}
              />
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="email"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Correo electrónico:
              </label>
              <div className="col">
                <InputText
                  id="email"
                  name="email"
                  value={datosOficial?.object?.email ?? ""}
                  autoComplete="off"
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-2"></div>
        <Fieldset legend="Domicilio">
          <div className="grid">
            <div className="col-12 md:col-4">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="provincia"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Provincia:
                </label>
                <div className="col">
                  <InputText
                    id="provincia"
                    name="provincia"
                    value={datosOficial?.object?.nomProvincia ?? ""}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="canton"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Cantón:
                </label>
                <div className="col">
                  <InputText
                    id="canton"
                    name="canton"
                    value={datosOficial?.object?.nomCanton ?? ""}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Parroquia:
                </label>
                <div className="col">
                  <InputText
                    id="parroquia"
                    name="parroquia"
                    value={datosOficial?.object?.nomParroquia ?? ""}
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 md:col-8">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Calle principal:
                </label>
                <div className="col">
                  <InputTextarea
                    id="callePrincipal"
                    name="callePrincipal"
                    value={datosOficial?.object?.callePrincipal ?? ""}
                    autoComplete="off"
                    disabled
                    rows={2}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="calleSecundaria"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Calle secundaria:
                </label>
                <div className="col">
                  <InputTextarea
                    id="calleSecundaria"
                    name="calleSecundaria"
                    value={datosOficial?.object?.calleSecundaria ?? ""}
                    autoComplete="off"
                    disabled
                    rows={2}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-6 ">
                <label
                  htmlFor="numero"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                >
                  Número:
                </label>
                <div className="col">
                  <InputText
                    id="numero"
                    name="numero"
                    value={datosOficial?.object?.txtNumero ?? ""}
                    autoComplete="off"
                    disabled
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="referencia"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                >
                  Referencia:
                </label>
                <div className="col">
                  <InputTextarea
                    id="referencia"
                    name="referencia"
                    disabled
                    rows={2}
                    value={datosOficial?.object?.txtReferencia ?? ""}
                    autoComplete="off"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Fieldset>
      </div>
    </>
  );
};
export default RevisarOficialCumplimientoConstitucion;
